import React, {Dispatch, useEffect, ReactElement} from "react";
import {useDispatch, useSelector} from "react-redux";
import MarkdownMedia from "../MarkdownMedia/MarkdownMedia";
import {GetPhaseDirectionsAction} from "../../interfaces/store/actions/job";
import Spinner from "../common/Spinner/Spinner";
import {getPhaseDirections} from "../../store/actions/job";
import "./TaskDirections.scss";
import {selectDescription} from "../../store/selectors/description";

interface Props {
    projectType?: string
    tocElements?: string[]
    readThroughContent?: boolean
    contentReadHandler?: Function | undefined
}

export const TaskDirections: React.FC<Props> = ({
    projectType, tocElements, readThroughContent, contentReadHandler,
}: Props): ReactElement => {
    const dispatch: Dispatch<GetPhaseDirectionsAction> = useDispatch();
    const directions: string = useSelector(selectDescription) || "";

    useEffect((): void => {
        if (!directions) {
            dispatch(getPhaseDirections());
        }
    }, [dispatch, directions]);

    return (
        <div className="df-task-directions">
            {!directions && <Spinner/>}
            <MarkdownMedia
                projectType={projectType}
                tocElements={tocElements}
                readThroughContent={readThroughContent}
                contentReadHandler={contentReadHandler}
            >
                {directions}
            </MarkdownMedia>
        </div>
    );
};

export default TaskDirections;

TaskDirections.defaultProps = {
    projectType: "",
    tocElements: ["h1"],
    readThroughContent: false,
    contentReadHandler: undefined,
};
